export const ACTIVITY_IMAGE_ALLOWED_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp'
] as const;

export const ACTIVITY_IMAGE_ALLOWED_EXTENSIONS = [
  'jpeg',
  'jpg',
  'png',
  'gif',
  'webp'
] as const;

export type ActivityImageAllowedMimeType =
  (typeof ACTIVITY_IMAGE_ALLOWED_MIME_TYPES)[number];

export const ACTIVITY_IMAGE_ACCEPT_ATTRIBUTE =
  ACTIVITY_IMAGE_ALLOWED_MIME_TYPES.join(',');

export const ACTIVITY_IMAGE_MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;

export const ACTIVITY_IMAGE_FILE_KEY_MAX_LENGTH = 1028;

export const ACTIVITY_IMAGE_STATUS = {
  LOADING: 'loading',
  LOADED: 'loaded',
  ERROR: 'error'
} as const;

export type ActivityImageStatus =
  (typeof ACTIVITY_IMAGE_STATUS)[keyof typeof ACTIVITY_IMAGE_STATUS];

export const UPLOAD_FILE_BUTTON_VARIANT = {
  BUTTON: 'button',
  TILE: 'tile'
} as const;

export type UploadFileButtonVariant =
  (typeof UPLOAD_FILE_BUTTON_VARIANT)[keyof typeof UPLOAD_FILE_BUTTON_VARIANT];
